<template>
  <footer class="t-gray tac fz-24 mt-40">
    <p>本服务由广州南方人才市场提供</p>
    <p>广州参数信息科技有限公司提供技术支持</p>
  </footer>
</template>

<script>
/** 页脚 */
export default {
  name: "Footer",
}
</script>
